import React, { FC } from 'react';

import classNames from 'classnames';

import { ButtonProps } from './types';
import styles from './Button.module.css';

export const Button: FC<ButtonProps> = props => {
  const {
    size = 'large',
    target = '_self',
    className,
    view,
    children,
    ...rest
  } = props;
  const classes = classNames(
    styles.button,
    className,
    styles[size],
    styles[view],
  );

  return (
    <a
      className={classes}
      href={props.to}
      target={target}
      rel="noreferrer"
      {...rest}
    >
      {children}
    </a>
  );
};
